import { useState } from 'react';
import AnimSection from '../components/AnimSection';
import { SERVICES, INDUSTRIES } from '../data';

export default function Contact() {
  const [form, setForm] = useState({ name:'', email:'', company:'', phone:'', service:'', industry:'', message:'' });
  const [sent, setSent] = useState(false);

  const update = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 6000);
    setForm({ name:'', email:'', company:'', phone:'', service:'', industry:'', message:'' });
  };

  return (
    <div className="page-enter" style={{ paddingTop:'66px' }}>

      {/* ── PAGE HERO ─────────────────────────── */}
      <div style={{ background:'var(--page-hero-soft)', padding:'5rem clamp(1.2rem,4vw,3rem) 4rem', borderBottom:'1px solid var(--border-1)', position:'relative', overflow:'hidden' }}>
        <div className="grid-bg" style={{ position:'absolute', inset:0 }} />
        <div className="sw" style={{ position:'relative', zIndex:1 }}>
          <div className="tag" style={{ marginBottom:'1rem' }}>Get a Quote</div>
          <h1 className="section-title" style={{ fontSize:'clamp(2.4rem,5vw,4rem)', marginBottom:'1rem' }}>LET'S <span className="highlight">CONNECT</span></h1>
          <p style={{ color:'var(--mu)', maxWidth:'560px', lineHeight:1.8, fontSize:'1.05rem' }}>
            Ready to take your operations to the next level? Contact us today. Our team answers within 4 business hours and offers a free, no-obligation consultation.
          </p>
        </div>
      </div>

      {/* ── FORM + INFO ───────────────────────── */}
      <div style={{ background:'var(--w2)', padding:'5rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw" style={{ display:'grid', gridTemplateColumns:'1fr 1.6fr', gap:'4.5rem' }}>

          {/* Contact Info */}
          <AnimSection>
            <h2 style={{ fontFamily:'var(--fH)', fontSize:'1.8rem', letterSpacing:'2px', marginBottom:'2rem' }}>CONTACT <span className="highlight">INFO</span></h2>

            {[
              { icon:'📍', l:'Head Office',       v:'F-68 Sector-3 DSIIDC\nBawana Industrial Area\nDelhi - 110039', href:'https://maps.app.goo.gl/LqDbPAUeHeHmvhd36' },
              { icon:'📧', l:'Email',             v:'info@elbotautomation.com', href:'mailto:info@elbotautomation.com' },
              { icon:'📞', l:'Phone',             v:'+91 95822 26718', href:'tel:+919582226718' },
              { icon:'💬', l:'WhatsApp',          v:'+91 95822 26718', href:'https://wa.me/919582226718' },
              { icon:'🕐', l:'Working Hours',     v:'Mon–Sat: 9:00 AM – 6:00 PM IST' },
              { icon:'⚡', l:'Emergency Support', v:'24/7 for contract clients' },
            ].map((c,i) => (
              <div key={i}
                style={{ display:'flex', gap:'1rem', padding:'1.1rem', marginBottom:'.8rem', background:'var(--w3)', borderRadius:'10px', border:'1px solid var(--border-3)', transition:'border-color .25s' }}
                onMouseEnter={e => e.currentTarget.style.borderColor='var(--accent-30)'}
                onMouseLeave={e => e.currentTarget.style.borderColor='var(--border-3)'}
              >
                <span style={{ fontSize:'1.3rem' }}>{c.icon}</span>
                <div>
                  <div style={{ fontFamily:'var(--fM)', color:'var(--o)', fontSize:'.67rem', letterSpacing:'2px', textTransform:'uppercase', marginBottom:'.2rem' }}>{c.l}</div>
                  {c.href ? (
                    <a href={c.href} target="_blank" rel="noopener noreferrer" style={{ color:'var(--dark)', fontSize:'.9rem', whiteSpace:'pre-line', textDecoration:'none', transition:'color .25s' }}
                      onMouseEnter={e => e.currentTarget.style.color='var(--o)'}
                      onMouseLeave={e => e.currentTarget.style.color='var(--dark)'}
                    >{c.v}</a>
                  ) : (
                    <div style={{ color:'var(--dark)', fontSize:'.9rem', whiteSpace:'pre-line' }}>{c.v}</div>
                  )}
                </div>
              </div>
            ))}

            {/* Certifications */}
            <div style={{ marginTop:'1.5rem', padding:'1.5rem', background:'var(--oL)', borderRadius:'10px', border:'1px solid var(--accent-20)' }}>
              <div style={{ fontFamily:'var(--fH)', fontSize:'.95rem', letterSpacing:'2px', color:'var(--o)', marginBottom:'.8rem' }}>CERTIFICATIONS</div>
              <div style={{ display:'flex', gap:'.5rem', flexWrap:'wrap' }}>
                {['ISO 9001','UL 508A','IEC 62443','CE Mark','CMMI L3'].map(c => <span key={c} className="chip">{c}</span>)}
              </div>
            </div>
          </AnimSection>

          {/* Form */}
          <AnimSection delay={.15}>
            <div className="card" style={{ padding:'3rem' }}>
              <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.6rem', letterSpacing:'1px', marginBottom:'.5rem' }}>REQUEST A <span className="highlight">QUOTE</span></h3>
              <div className="divider" />

              {sent && (
                <div style={{ padding:'1rem 1.5rem', background:'var(--oL)', border:'1px solid var(--accent-20)', borderRadius:'8px', color:'var(--o)', fontFamily:'var(--fM)', fontSize:'.88rem', marginBottom:'1.5rem', animation:'fadeIn .4s ease' }}>
                  ✅ Message received! We'll be in touch within 4 business hours.
                </div>
              )}

              <form onSubmit={submit} style={{ display:'flex', flexDirection:'column', gap:'1.1rem' }}>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
                  <div>
                    <label style={{ fontFamily:'var(--fM)', fontSize:'.68rem', color:'var(--o)', letterSpacing:'2px', textTransform:'uppercase', display:'block', marginBottom:'.5rem' }}>Full Name *</label>
                    <input className="form-input" required placeholder="John Smith" value={form.name} onChange={update('name')} />
                  </div>
                  <div>
                    <label style={{ fontFamily:'var(--fM)', fontSize:'.68rem', color:'var(--o)', letterSpacing:'2px', textTransform:'uppercase', display:'block', marginBottom:'.5rem' }}>Email *</label>
                    <input className="form-input" required type="email" placeholder="john@company.com" value={form.email} onChange={update('email')} />
                  </div>
                </div>

                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
                  <div>
                    <label style={{ fontFamily:'var(--fM)', fontSize:'.68rem', color:'var(--o)', letterSpacing:'2px', textTransform:'uppercase', display:'block', marginBottom:'.5rem' }}>Company</label>
                    <input className="form-input" placeholder="Your Company" value={form.company} onChange={update('company')} />
                  </div>
                  <div>
                    <label style={{ fontFamily:'var(--fM)', fontSize:'.68rem', color:'var(--o)', letterSpacing:'2px', textTransform:'uppercase', display:'block', marginBottom:'.5rem' }}>Phone</label>
                    <input className="form-input" placeholder="+91 00000 00000" value={form.phone} onChange={update('phone')} />
                  </div>
                </div>

                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
                  <div>
                    <label style={{ fontFamily:'var(--fM)', fontSize:'.68rem', color:'var(--o)', letterSpacing:'2px', textTransform:'uppercase', display:'block', marginBottom:'.5rem' }}>Service Required</label>
                    <select className="form-input" value={form.service} onChange={update('service')}>
                      <option value="">Select service...</option>
                      {SERVICES.map(s => <option key={s.title}>{s.title}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ fontFamily:'var(--fM)', fontSize:'.68rem', color:'var(--o)', letterSpacing:'2px', textTransform:'uppercase', display:'block', marginBottom:'.5rem' }}>Your Industry</label>
                    <select className="form-input" value={form.industry} onChange={update('industry')}>
                      <option value="">Select industry...</option>
                      {INDUSTRIES.map(i => <option key={i.name}>{i.name}</option>)}
                    </select>
                  </div>
                </div>

                <div>
                  <label style={{ fontFamily:'var(--fM)', fontSize:'.68rem', color:'var(--o)', letterSpacing:'2px', textTransform:'uppercase', display:'block', marginBottom:'.5rem' }}>Project Description *</label>
                  <textarea className="form-input" required rows={5} placeholder="Tell us about your project, current challenges, and what you hope to achieve..." value={form.message} onChange={update('message')} style={{ resize:'vertical' }} />
                </div>

                <button type="submit" className="btn-primary" style={{ justifyContent:'center', fontSize:'1.1rem', padding:'15px' }}>
                  Send Request →
                </button>
                <p style={{ color:'var(--mu)', fontSize:'.75rem', textAlign:'center', fontFamily:'var(--fM)' }}>
                  We reply within 4 business hours · Free consultation · No commitment required
                </p>
              </form>
            </div>
          </AnimSection>
        </div>

        {/* ── FAQ ─────────────────────────────── */}
        <div className="sw" style={{ marginTop:'5rem' }}>
          <AnimSection style={{ textAlign:'center', marginBottom:'3rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Common Questions</div>
            <h2 className="section-title">FREQUENTLY <span className="highlight">ASKED</span></h2>
            <div className="divider" style={{ margin:'1rem auto 0' }} />
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1.2rem' }}>
            {[
              { q:'How long does a typical project take?',        a:'Project timelines vary from 2 weeks for small PLC programming tasks to 36+ weeks for full facility automation. We provide a detailed project schedule at the proposal stage.' },
              { q:'Do you offer a warranty on your work?',        a:'Yes — all projects include a 12-month warranty covering both hardware and software faults. Extended support and maintenance contracts are also available.' },
              { q:'Can you work with our existing equipment?',    a:'Absolutely. Retrofitting and integrating legacy equipment is one of our specialities. We perform detailed audits to determine the most cost-effective approach before any work begins.' },
              { q:'What industries do you serve?',                a:'We have delivered projects across automotive, pharmaceutical, food & beverage, logistics, energy, utilities, and general manufacturing — and more. If in doubt, just ask.' },
              { q:'Do you provide remote support?',               a:'Yes. We offer secure remote monitoring and support for all commissioned systems, with 24/7 availability for contract maintenance clients.' },
              { q:'How is pricing structured?',                   a:'We use fixed-price contracts wherever possible — clients always know their total cost upfront with no unexpected invoices. Some service contracts are time-and-materials based.' },
            ].map((f,i) => (
              <AnimSection key={i} delay={i*.05}>
                <div className="card" style={{ padding:'1.8rem' }}>
                  <div style={{ fontFamily:'var(--fH)', fontSize:'1rem', letterSpacing:'1.5px', marginBottom:'.7rem', color:'var(--dark)' }}>Q: {f.q}</div>
                  <p style={{ color:'var(--mu)', fontSize:'.88rem', lineHeight:1.75 }}>{f.a}</p>
                </div>
              </AnimSection>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
}
